import { I18NGetter } from "@/services/enumTranslator/I18NGetter";
import { IncomeType } from "../Types";

export const incomeTypesNames: Record<IncomeType, string> = {
  [IncomeType.CONTRACT_PERMANENT]: I18NGetter().useIncomeTypesNames.CONTRACT_PERMANENT,
  [IncomeType.CONTRACT_FIXED_TERM]: I18NGetter().useIncomeTypesNames.CONTRACT_FIXED_TERM,
  [IncomeType.CONTRACT_MANDATE_OR_SPECIFIC_WORK]: I18NGetter().useIncomeTypesNames.CONTRACT_MANDATE_OR_SPECIFIC_WORK,
  [IncomeType.APPOINTMENT]: I18NGetter().useIncomeTypesNames.APPOINTMENT,
  [IncomeType.CONTRACT_SEA]: I18NGetter().useIncomeTypesNames.CONTRACT_SEA,
  [IncomeType.CONTRACT_MANAGER]: I18NGetter().useIncomeTypesNames.CONTRACT_MANAGER,
  [IncomeType.CONTRACT_MILITARY]: I18NGetter().useIncomeTypesNames.CONTRACT_MILITARY,
  [IncomeType.BUSINESS_KPIR]: I18NGetter().useIncomeTypesNames.BUSINESS_KPIR,
  [IncomeType.BUSINESS_FLAT_TAX]: I18NGetter().useIncomeTypesNames.BUSINESS_FLAT_TAX,
  [IncomeType.BUSINESS_CARD_TAX]: I18NGetter().useIncomeTypesNames.BUSINESS_CARD_TAX,
  [IncomeType.BUSINESS_FULL_ACCOUNTING]: I18NGetter().useIncomeTypesNames.BUSINESS_FULL_ACCOUNTING,
  [IncomeType.BUSINESS_FARMER]: I18NGetter().useIncomeTypesNames.BUSINESS_FARMER,
  [IncomeType.BUSINESS_B2B_KPIR]: I18NGetter().useIncomeTypesNames.BUSINESS_B2B_KPIR,
  [IncomeType.BUSINESS_B2B_FLAT_TAX]: I18NGetter().useIncomeTypesNames.BUSINESS_B2B_FLAT_TAX,
  [IncomeType.INCOME_FROM_ABROAD_PERMANENT_CONTRACT]: I18NGetter().useIncomeTypesNames.INCOME_FROM_ABROAD_PERMANENT_CONTRACT,
  [IncomeType.INCOME_FROM_ABROAD_FIXED_TERM_CONTRACT]: I18NGetter().useIncomeTypesNames.INCOME_FROM_ABROAD_FIXED_TERM_CONTRACT,
  [IncomeType.INCOME_FROM_ABROAD_BUSINESS]: I18NGetter().useIncomeTypesNames.INCOME_FROM_ABROAD_BUSINESS,
  [IncomeType.INCOME_FROM_ABROAD_PENSION]: I18NGetter().useIncomeTypesNames.INCOME_FROM_ABROAD_PENSION,
  [IncomeType.INCOME_FROM_ABROAD_OTHER]: I18NGetter().useIncomeTypesNames.INCOME_FROM_ABROAD_OTHER,
  [IncomeType.RENT]: I18NGetter().useIncomeTypesNames.RENT,
  [IncomeType.PERMANENT_PENSION]: I18NGetter().useIncomeTypesNames.PERMANENT_PENSION,
  [IncomeType.RETIREMENT]: I18NGetter().useIncomeTypesNames.RETIREMENT,
  [IncomeType.PRIEST]: I18NGetter().useIncomeTypesNames.PRIEST,
  [IncomeType.MATERNITY_LEAVE]: I18NGetter().useIncomeTypesNames.MATERNITY_LEAVE,
  [IncomeType.DRIVERS_ALLOWANCE]: I18NGetter().useIncomeTypesNames.DRIVERS_ALLOWANCE,
  [IncomeType.HOUSING_SUPPLEMENT]: I18NGetter().useIncomeTypesNames.HOUSING_SUPPLEMENT,
  [IncomeType.DIVIDENDS]: I18NGetter().useIncomeTypesNames.DIVIDENDS,
  [IncomeType.BUSINESS_3]: "---",
  [IncomeType.BUSINESS_5]: "---",
  [IncomeType.BUSINESS_8]: "---",
  [IncomeType.BUSINESS_17_20]: "---",
  [IncomeType.CONTRACT_MANDATE]: "---",
  [IncomeType.STRUCTURE_PENSION]: "---",
  [IncomeType.PRE_PENSION]: "---",
  [IncomeType.TERM_PENSION]: "---",
  [IncomeType.WITHOUT_INCOME]: "---",
  [IncomeType.SOCIAL_500]: "---",
  [IncomeType.BUSINESS_15]: "---",
  [IncomeType.BUSINESS_12]: "---",
  [IncomeType.BUSINESS_10]: "---",
  [IncomeType.BUSINESS_2]: "---"
}